import moment from 'moment';

export const fields = [
    { id: 'flight', label: 'flightPage.flight' },
    { id: 'pln', label: 'flightPage.ACReg' },
    { id: 'task', label: 'flightPage.flightTask' },
    { id: 'operatorEng', label: 'flightPage.АСOperator' },
    { id: 'flightCommunicationType', label: 'flightPage.communication' },
    { id: 'flightMeanType', label: 'flightPage.flightMeanType' },
    { id: 'flightType', label: 'flightPage.flightType' },
    { id: 'passengersMax', label: 'flightPage.seatConfiguration' },
    { id: 'statusCode', label: 'flightPage.status' },
    { id: 'markCodeCompany', label: 'flightPage.comment', full: true },
    { id: 'markFlightNumber', label: 'flightPage.flightComment', full: true },
];

export const getValue = (props, id, isEng = false) => {
    const { flight = {}, task = {} } = props || {};
    const { num, numEng, date, route } = flight;
    const { flightTask, taskDate } = task;

    switch (id) {
        case 'flight':
            return `${isEng ? numEng : num} / ${moment(date).format('DD.MM.YY')}`;
        case 'task':
            return `${flightTask} ${moment(taskDate).format('DD.MM.YY')} (${route})`;
    }

    return flight[id];
};
